import { ActionTypes, ReduxAction } from './types';
import { GefahrgutklasseService, VerpackungService } from '../../api';
import { Dispatch } from 'redux';

export const searchVerpackungen =
  (verpackungsName: string) => async (dispatch: Dispatch<ReduxAction>) => {
    if (!verpackungsName) return null;
    new VerpackungService()
      .searchVerpackungen(verpackungsName)
      .then(response => {
        dispatch({
          type: ActionTypes.SEARCH_VERPACKUNGEN,
          payload: response.data,
        });
      });
  };

export const searchGefahrgutklassen =
  (text: string | undefined, rowNumber: number | undefined) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new GefahrgutklasseService()
      .searchGefahrgutklassen('', text)
      .then(response => {
        dispatch({
          type: ActionTypes.SEARCH_GEFAHRGUTKLASSEN,
          payload: response.data,
        });
      });
  };

export const searchUnnr =
  (text: string | undefined) => async (dispatch: Dispatch<ReduxAction>) => {
    new GefahrgutklasseService()
      .searchGefahrgutklassen(text, '')
      .then(response => {
        dispatch({
          type: ActionTypes.SEARCH_GEFAHRGUTKLASSEN,
          payload: response.data,
        });
      });
  };
